import { SubflowSteps } from '@/types/steps';

export type ProgressBarStep = {
  title: string;
  substeps: (typeof SubflowSteps)[keyof typeof SubflowSteps][];
};

/**
 * NOTE: Kind of duplicate code that doesn't respect multiple flows, but works for now
 */
export const PROGRESS_BAR_STEPS: ProgressBarStep[] = [
  {
    title: 'Parent',
    substeps: [SubflowSteps.Intro, SubflowSteps.Name, SubflowSteps.Email]
  },
  {
    title: 'Pet',
    substeps: [
      SubflowSteps.GenderBreed,
      SubflowSteps.Age,
      SubflowSteps.WeightActivity,
      SubflowSteps.Waistline,
      SubflowSteps.SensitivitiesGoals,
      SubflowSteps.PlanPreferences
    ]
  },
  {
    title: 'Plan',
    substeps: [SubflowSteps.Plans]
  },
  {
    title: 'Checkout',
    substeps: [SubflowSteps.PlanConfirmation]
  }
];
